export const sanitizeString = (value) => value.replaceAll(/(<script)(.*)(>)(.*)(<\/script>)/gi, "");
